import { render } from "./Text2Cols.vue?vue&type=template&id=ad15b75a"
import script from "./Text2Cols.vue?vue&type=script&lang=js"
export * from "./Text2Cols.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__